export enum AccountType {
	Asset = 1,
	Liability = 2,
	Reserve = 3,
	Revenue = 4,
	Expense = 5,
	Net = 6,
}

export enum AccountTypeDescEnum {
	Asset = 'Asset',
	Liability = 'Liability',
	Reserve = 'Reserve',
	Revenue = 'Revenue',
	Expense = 'Expense',
	Net = 'Net',
}
